import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M36.06 17.715c0-3.245-.06-5.872-.182-7.88a4.916 4.916 0 0 0-4.468-4.6c-2.002-.179-4.385-.269-7.147-.269-2.764 0-5.149.09-7.152.27a4.916 4.916 0 0 0-4.469 4.61c-.117 2.022-.176 4.677-.176 7.964 0 7.205.283 15.613.85 25.224l8.024-8.025c.812-.811 1.312-1.15 1.981-1.352a3.216 3.216 0 0 1 1.884 0c.67.203 1.17.54 1.982 1.352l8.021 8.022c.569-9.87.853-18.31.853-25.316Zm1.781-7.999c.124 2.053.186 4.718.186 7.999 0 7.047-.285 15.523-.856 25.429a1.966 1.966 0 0 1-3.353 1.277l-8.022-8.022c-.601-.601-.843-.764-1.16-.86a1.25 1.25 0 0 0-.744 0c-.319.096-.56.259-1.161.86l-8.025 8.025a1.966 1.966 0 0 1-3.353-1.274c-.569-9.647-.853-18.093-.853-25.34 0-3.322.06-6.013.18-8.077a6.882 6.882 0 0 1 6.255-6.455C19.002 3.092 21.445 3 24.263 3c2.817 0 5.257.092 7.322.277a6.882 6.882 0 0 1 6.256 6.44Zm-14.56 8.03v-3.932c0-1.31 1.966-1.31 1.966 0v3.933h3.932c1.31 0 1.31 1.966 0 1.966h-3.932v3.932c0 1.31-1.967 1.31-1.967 0v-3.932h-3.932c-1.31 0-1.31-1.966 0-1.966h3.932Z",
      clipRule: "evenodd"
    }
  )
);
var SvgBookmarkAddOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BookmarkAddOutlined_default = SvgBookmarkAddOutlined;

export { BookmarkAddOutlined_default as default };
